/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Role } from './role';


export interface User {
    activated?: boolean;
    email?: string;
    firstName?: string;
    id?: string;
    imageUrl?: string;
    langKey?: string;
    lastName?: string;
    login: string;
    resetDate?: string;
    role?: Role;
    roleExpiration?: string;
}

